import apiClient from '@/api/ApiClient'
import ResponseHandler from '@/api/response/ResponseHandler'
import SelectApiClientType from '@/api/SelectApiClientType'

class SelectApiClient {
    restaurants(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/restaurants', {
                params: queryParams || {},
            })
        )
    }

    companies(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/companies', {
                params: queryParams || {},
            })
        )
    }

    companyAllowances(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/company-allowances', {
                params: queryParams || {},
            })
        )
    }

    users(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/users', {
                params: queryParams || {},
            })
        )
    }

    companyAddress(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/company-addresses', {
                params: queryParams || {},
            })
        )
    }

    paymentMethods() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/payment-methods')
        )
    }

    companyAllowanceBalanceTypes() {
        return ResponseHandler.handle(
            apiClient.get(
                '/api/v1/select-options/company-allowance-balance-types'
            )
        )
    }

    companyAllowanceTimeUnits() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/company-allowance-time-units')
        )
    }

    promotionTypes() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/promotion-types')
        )
    }

    promotionDiscountTypes() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/promotion-discount-types')
        )
    }

    restaurantPriceCategories() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/restaurant-price-category')
        )
    }

    restaurantTags(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/restaurant-tags', {
                params: queryParams || {},
            })
        )
    }

    restaurantTagGroups(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/restaurant-tag-groups', {
                params: queryParams || {},
            })
        )
    }

    restaurantDeliveryAreaTypes() {
        return ResponseHandler.handle(
            apiClient.get(
                '/api/v1/select-options/restaurant-delivery-area-types'
            )
        )
    }

    orderingSoftwares() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/ordering-software')
        )
    }

    allergens() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/allergens')
        )
    }

    allergensSuitability() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/allergens-suitability', {
                params: {
                    translate: 0,
                },
            })
        )
    }

    allergensAdditional() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/allergens-additional')
        )
    }

    vat() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/vat')
        )
    }

    mealCategory(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/meal-category', {
                params: queryParams || {},
            })
        )
    }

    mealOptionGroup(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/meal-option-group', {
                params: queryParams || {},
            })
        )
    }

    countries() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/country')
        )
    }

    suitableForConstraints() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/suitable-for-constraints')
        )
    }

    meals(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/meal', {
                params: queryParams || {},
            })
        )
    }

    orderStatus() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/order-status')
        )
    }

    orderRefundBehalf() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/refund-on-behalf')
        )
    }

    vehicleTypes() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/delivery-vehicle-types')
        )
    }

    deliveryMethods() {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/delivery-methods')
        )
    }

    deliveryNotificationTemplates() {
        return ResponseHandler.handle(
            apiClient.get(
                '/api/v1/select-options/delivery-notification-template'
            )
        )
    }

    userNotifications(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/user-notification-settings', {
                params: queryParams || {},
            })
        )
    }

    residentialCanteenAddresses(queryParams) {
        return ResponseHandler.handle(
            apiClient.get(
                '/api/v1/select-options/residential-canteen-addresses',
                {
                    params: queryParams || {},
                }
            )
        )
    }

    residentialCanteenRestaurants(queryParams) {
        return ResponseHandler.handle(
            apiClient.get(
                '/api/v1/select-options/residential-canteen-restaurants',
                {
                    params: queryParams || {},
                }
            )
        )
    }

    userExtraRoles(queryParams) {
        return ResponseHandler.handle(
            apiClient.get('/api/v1/select-options/extra-roles', {
                params: queryParams || {},
            })
        )
    }

    getByEntityName(entity, queryParams) {
        switch (entity) {
            case SelectApiClientType.COMPANY:
                return this.companies(queryParams)
            case SelectApiClientType.RESTAURANT:
                return this.restaurants(queryParams)
            case SelectApiClientType.COMPANY_ALLOWANCE:
                return this.companyAllowances(queryParams)
            case SelectApiClientType.USER:
                return this.users(queryParams)
            case SelectApiClientType.COMPANY_ADDRESS:
                return this.companyAddress(queryParams)
            case SelectApiClientType.PAYMENT_METHODS:
                return this.paymentMethods()
            case SelectApiClientType.COMPANY_ALLOWANCE_BALANCE_TYPES:
                return this.companyAllowanceBalanceTypes()
            case SelectApiClientType.COMPANY_ALLOWANCE_TIME_UNITS:
                return this.companyAllowanceTimeUnits()
            case SelectApiClientType.PROMOTION_TYPES:
                return this.promotionTypes()
            case SelectApiClientType.PROMOTION_DISCOUNT_TYPES:
                return this.promotionDiscountTypes()
            case SelectApiClientType.RESTAURANT_PRICE_CATEGORIES:
                return this.restaurantPriceCategories()
            case SelectApiClientType.RESTAURANT_TAGS:
                return this.restaurantTags(queryParams)
            case SelectApiClientType.RESTAURANT_TAG_GROUPS:
                return this.restaurantTagGroups(queryParams)
            case SelectApiClientType.RESTAURANT_DELIVERY_AREA_TYPE:
                return this.restaurantDeliveryAreaTypes()
            case SelectApiClientType.ORDERING_SOFTWARE:
                return this.orderingSoftwares()
            case SelectApiClientType.ALLERGENS:
                return this.allergens()
            case SelectApiClientType.ALLERGENS_SUITABILITY:
                return this.allergensSuitability()
            case SelectApiClientType.ALLERGENS_ADDITIONAL:
                return this.allergensAdditional()
            case SelectApiClientType.VAT:
                return this.vat()
            case SelectApiClientType.MEAL_CATEGORY:
                return this.mealCategory(queryParams)
            case SelectApiClientType.MEAL_OPTION_GROUP:
                return this.mealOptionGroup(queryParams)
            case SelectApiClientType.COUNTRY:
                return this.countries()
            case SelectApiClientType.SUITABLE_FOR_CONSTRAINTS:
                return this.suitableForConstraints()
            case SelectApiClientType.MEAL:
                return this.meals(queryParams)
            case SelectApiClientType.ORDER_STATUS:
                return this.orderStatus()
            case SelectApiClientType.ORDER_REFUND_BEHALF:
                return this.orderRefundBehalf()
            case SelectApiClientType.VEHICLE_TYPE:
                return this.vehicleTypes()
            case SelectApiClientType.DELIVERY_METHOD:
                return this.deliveryMethods()
            case SelectApiClientType.DELIVERY_NOTIFICATION_TEMPLATE:
                return this.deliveryNotificationTemplates()
            case SelectApiClientType.USER_NOTIFICATIONS:
                return this.userNotifications()
            case SelectApiClientType.RESIDENTIAL_CANTEEN_ADDRESS:
                return this.residentialCanteenAddresses(queryParams)
            case SelectApiClientType.RESIDENTIAL_CANTEEN_RESTAURANT:
                return this.residentialCanteenRestaurants(queryParams)
            case SelectApiClientType.USER_EXTRA_ROLES:
                return this.userExtraRoles(queryParams)
        }
    }
}

export default new SelectApiClient()
